var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocializingWithFriendsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 1a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h3a1 1 0 0 1 1 1v2.586c0 .89 1.077 1.337 1.707.707l4-4a1 1 0 0 1 .707-.293H22a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.707 21.293 7 20.586l.707.707ZM2 2V0a2 2 0 0 0-2 2h2Zm0 14V2H0v14h2Zm0 0H0a2 2 0 0 0 2 2v-2Zm3 0H2v2h3v-2Zm2 4.586V18H5v2.586h2Zm4-4-4 4L8.414 22l4-4L11 16.586ZM22 16h-9.586v2H22v-2Zm0 0v2a2 2 0 0 0 2-2h-2Zm0-14v14h2V2h-2Zm0 0h2a2 2 0 0 0-2-2v2ZM2 2h20V0H2v2Zm10.414 16v-2a2 2 0 0 0-1.414.586L12.414 18ZM5 20.586C5 22.368 7.154 23.26 8.414 22L7 20.586H5ZM5 18h2a2 2 0 0 0-2-2v2Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 10V8M7 10V8m5 3V7",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocializingWithFriendsActive);
export default __webpack_public_path__ + "static/media/socializing-with-friends-active.7cc1faa9079b02bd0d7b2b33a2d4e6e8.svg";
export { ForwardRef as ReactComponent };